// src/redux/reducers/dislikeReducer.js

const initialState = {
  sent: [],      // dislikes envoyés par l'utilisateur
};

const dislikeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_DISLIKES_SENT":
      return { ...state, sent: action.payload };
    case "ADD_DISLIKE_SENT":
      return { ...state, sent: [...state.sent, action.payload] };
    default:
      return state;
  }
};
export default dislikeReducer;